import en from '../../translation/en_GB'

export default {
  // i18nConfiguration
  i18n: {
    locales: [
      {
        code: 'en',
        iso: 'en-GB',
      },
    ],
    defaultLocale: 'en',
    vueI18n: {
      fallbackLocale: 'en',
      messages: {
        en,
      },
    },
    pages: {
      'categories/inspirations': {
        en: '/inspiration',
      },
      'categories/gifts': {
        en: '/gifts',
      },
      'categories/occasions': {
        en: '/occasions',
      },
      'categories/tutorials-and-advices': {
        en: '/tips-and-tutorials',
      },
      'categories/home-furnishing': {
        en: '/home-decor',
      },
      'editorial-staff/index': {
        en: '/redazione',
      },
      'editorial-staff/_author': {
        en: '/redazione/:author?',
      },
    },
  },
  /* 
    Categories Configuration
    @order: [] è l'array delle chiavi delle categorie e rappresenta l'ordine con cui verranno visualizzate le categorie dove richieste
    list{
        @key è la chiave della categoria. Per convenzione chiamata come il folder dentro page.
        {
          @slug è lo slug della categoria inserito in categorie su Wordpress
          @view è la view di nuxt e corrisponde al name utilizzato nei nuxt-link
        }
    }
  */
  pages: {
    // leggere README.md
    list: [
      {
        key: 'index', // Home per comodità la trattiamo come una categoria
        wpUri: '/?page_id=104',
      },
      {
        key: 'inspirations',
        wpUri: '/?page_id=108',
      },
      {
        key: 'gifts',
        wpUri: '/?page_id=110',
      },
      {
        key: 'occasions',
        wpUri: '/?page_id=106',
      },
      {
        key: 'tutorials-and-advices',
        wpUri: '/?page_id=112',
      },
      {
        key: 'home-furnishing',
        wpUri: '/?page_id=114',
      },
      {
        key: 'editorial-staff',
        wpUri: '/redazione/',
      },
    ],
  },
  categories: {
    // leggere README.md
    list: [
      {
        key: 'inspirations',
        wpSlug: 'inspirations',
        view: 'categories-inspirations',
        wpCategoryId: 5,
      },
      {
        key: 'gifts',
        wpSlug: 'gifts',
        view: 'categories-gifts',
        wpCategoryId: 6,
      },
      {
        key: 'occasions',
        wpSlug: 'occasions',
        view: 'categories-occasions',
        wpCategoryId: 4,
      },
      {
        key: 'tutorials-and-advices',
        wpSlug: 'tutorials-and-advices',
        view: 'categories-tutorials-and-advices',
        wpCategoryId: 8,
      },
      {
        key: 'home-furnishing',
        wpSlug: 'home-furnishing',
        view: 'categories-home-furnishing',
        wpCategoryId: 7,
      },
      {
        key: 'highlights',
        wpSlug: 'highlights',
        view: null,
        wpCategoryId: 3,
      },
    ],
  },
  giftaWebsite: 'https://www.gifta.com/',
  navigation: {
    primary: {
      order: [
        'inspirations',
        'gifts',
        'occasions',
        'tutorials-and-advices',
        'home-furnishing',
      ],
    },
    // Categorie che vengono filtrate da eventuali elenchi (es. la lista delle categorie a cui appartiene un post)
    exclude: ['highlights'],
  },
  social: [
    {
      key: 'facebook',
      url: 'https://www.facebook.com/Giftacom-105537068061388',
    },
    {
      key: 'instagram',
      url: 'https://www.instagram.com/gifta_com/?hl=it',
    },
  ],
  terms: [
    {
      key: 'privacy-policy',
      url: 'https://www.gifta.com/privacy-policy/',
    },
    {
      key: 'cookie-policy',
      url: 'https://www.gifta.com/cookie/',
    },
    {
      key: 'informazioni-legali',
      url: 'https://www.gifta.com/legal-information/',
    },
  ],
  pixaLinks: [
    {
      key: 'books-magazines',
      url: 'https://www.pixartprinting.co.uk/printing-magazines-books-catalogues/',
    },
    {
      key: 'business-cards',
      url: 'https://www.pixartprinting.co.uk/business-cards/',
    },
    {
      key: 'flyers',
      url: 'https://www.pixartprinting.co.uk/digital-litho-printing/printing-leaflets-flyers/',
    },
  ],
  shopLinks: [
    {
      label: 'Personalised Gifts',
      url: 'https://www.gifta.com/personalised-gifts/',
    },
    {
      label: 'Canvas Printing',
      url: 'https://www.gifta.com/canvas-prints/',
    },
    {
      label: 'Personalised Canvas Prints',
      url: 'https://www.gifta.com/canvas-prints/custom-canvas-prints/',
    },
    {
      label: 'Wall Art',
      url: 'https://www.gifta.com/wall-art/',
    },
    {
      label: 'Photo Gifts',
      url: 'https://www.gifta.com/photo-gifts/',
    },
    {
      label: 'Personalised Cushions',
      url: 'https://www.gifta.com/photo-gifts/personalised-cushions/',
    },
    {
      label: 'Personalised Mugs',
      url: 'https://www.gifta.com/photo-gifts/personalised-mugs/',
    },
    {
      label: 'Personalised Tote Bags',
      url: 'https://www.gifta.com/photo-gifts/personalised-tote-bags/',
    },
    {
      label: 'Personalised T-Shirts',
      url: 'https://www.gifta.com/t-shirt-printing/',
    },
    {
      label: 'Photo Books',
      url: 'https://www.gifta.com/photo-books/',
    },
    {
      label: 'Photo Calendars',
      url: 'https://www.gifta.com/photo-calendars/',
    },
    {
      label: 'Gift Ideas',
      url: 'https://www.gifta.com/gift-ideas/',
    },
  ],
  nuxtConfiguration: {
    head: {
      script: [
        {
          src: 'https://21fd768e7ea04855a8a850bd8ab542cf.js.ubembed.com',
          async: true,
        },
      ],
    },
  },
}
